import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import logo from '../projectitems/arth2.png';
import logoBeyaz from '../projectitems/logobeyaz.png';

const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 60);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [menuOpen]);

    const scrollTo = (id) => {
        setMenuOpen(false);
        if (id === '#') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
        const el = document.querySelector(id);
        if (el) {
            const offset = 80;
            const top = el.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    };

    const navLinks = [
        { label: 'Hakkımızda', href: '#terra' },
        { label: 'Hizmetlerimiz', href: '#magaza' },
        { label: 'Projelerimiz', href: '#uygulamalar' },
        { label: 'Ürünlerimiz', href: '#urunler' },
        { label: 'Makinelerimiz', href: '#makineler' },
        { label: 'Neden Biz', href: '#hizmetler' },
        { label: 'İletişim', href: '#iletisim' },
    ];

    return (
        <>
            <header className={`header ${scrolled ? 'scrolled' : ''}`}>
                <div className="header__inner">
                    <button className="logo logo-btn" onClick={() => scrollTo('#')}>
                        <img src={logo} alt="ARTH YAPI İÇ MİMARLIK" className="logo__image" />
                        <div className="logo__text">
                            <span className="logo__name">ARTH</span>
                            <span className="logo__sub">YAPI</span>
                        </div>
                    </button>

                    <nav className="nav">
                        {navLinks.map((l) => (
                            <button key={l.label} className="nav__link" onClick={() => scrollTo(l.href)}>
                                {l.label}
                            </button>
                        ))}
                    </nav>

                    <button
                        className={`hamburger ${menuOpen ? 'open' : ''}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Menü"
                        aria-expanded={menuOpen}
                    >
                        <span /><span /><span />
                    </button>
                </div>
            </header>

            {menuOpen && createPortal(
                <div className="mobile-menu">
                    <button
                        className="mobile-menu__close"
                        onClick={() => setMenuOpen(false)}
                        aria-label="Kapat"
                    >
                        ✕
                    </button>
                    <button className="mobile-menu__logo" onClick={() => scrollTo('#')}>
                        <img src={logoBeyaz} alt="ARTH YAPI" className="mobile-menu__logo-img" />
                        <span className="mobile-menu__logo-text">ARTHYAPI</span>
                    </button>
                    {navLinks.map((l) => (
                        <button key={l.label} className="mobile-menu__link" onClick={() => scrollTo(l.href)}>
                            {l.label}
                        </button>
                    ))}
                </div>,
                document.body
            )}
        </>
    );
};

export default Header;
